import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 8B150753-A2AC-4750-B6EC-686D213805DE
 * name minus-box-multiple
 * version: 4.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/minus-box-multiple.svg
 * tags
 * - Form 
 */
export const MinusBoxMultipleIcon = createSvgIcon(<><path d="M19 11H9V9H19M20 2H8C6.9 2 6 2.9 6 4V16C6 17.11 6.9 18 8 18H20C21.11 18 22 17.11 22 16V4C22 2.9 21.11 2 20 2M4 6H2V20C2 21.11 2.9 22 4 22H18V20H4V6Z" /></>, 'MinusBoxMultipleIcon');
export default MinusBoxMultipleIcon